export type FNode = {tag:any;props:any;children:any[]};
export function figmaElement(tag:any, props:any, ...children:any[]):FNode {
  const flat=children.flat(Infinity).filter(x=>x!==false&&x!==true&&x!=null);
  if(typeof tag==='function')return tag({...props,children:flat});
  return {tag,props:props||{},children:flat};
}
